import {
  RoomId,
  roomId,
  StreamId,
  streamId,
  streamIsActive,
  StreamIsActive
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutFocusSetCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutFocusSetCmd.validationSchema()
  );

  constructor(readonly cmd: RoomStageLayoutFocusSet) {
    JsonSchemaValidator.assert(RoomStageLayoutFocusSetCmd.validation, cmd);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId", "streamIsActive"],
      properties: {
        roomId,
        streamId,
        streamIsActive
      }
    };
  }
}

interface RoomStageLayoutFocusSet {
  roomId: RoomId;
  streamId: StreamId;
  streamIsActive: StreamIsActive;
}
